var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirefoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.415,
    height: 50,
    viewBox: "0 0 48.415 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.898,
    y1: 0.155,
    x2: 0.066,
    y2: 0.932,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#ffe847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#ffc830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#ff8b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462,
    stopColor: "#ff672a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#e31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1.387,
    cy: 0.515,
    r: 1.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#ffbd4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#ffac31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#ff9d17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#ff563b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#ff3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f5156c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#eb0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 1,
    cy: 1.039,
    r: 1.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960e18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#b11927",
    stopOpacity: 0.741
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#db293d",
    stopOpacity: 0.341
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#f5334b",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 2.089,
    cy: 0.642,
    r: 1.855,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#ffdc3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#ff9d12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#ff980e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.752,
    cy: 1.61,
    r: 1.019,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3a8ee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5c79f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c139e6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.938,
    cy: 0.605,
    r: 0.541,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8c4ff3",
    stopOpacity: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716a8",
    stopOpacity: 0.451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6e008b",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 1.611,
    cy: 0.56,
    r: 1.938,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#e31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 1.347,
    cy: 0.772,
    r: 2.387,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff980e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#ff5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#ff3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#e31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 2.963,
    cy: 1.113,
    r: 3.128,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#fff44f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#ffe141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#ffaf1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#ff980e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.887,
    y1: 0.151,
    x2: 0.18,
    y2: 0.836,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#fff44f",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#fff44f",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff44f",
    stopOpacity: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff44f",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "firefox",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6105",
    "data-name": "Path 6105",
    d: "M47.66,16.788c-1.053-2.534-3.189-5.27-4.862-6.135a25.181,25.181,0,0,1,2.454,7.354l0,.041c-2.74-6.829-7.385-9.586-11.181-15.583-.192-.3-.384-.607-.571-.928-.107-.183-.193-.348-.267-.5a4.409,4.409,0,0,1-.361-.96.063.063,0,0,0-.055-.063.087.087,0,0,0-.046,0s-.008.006-.012.007L32.746.03l.009-.016a17.677,17.677,0,0,0-8.342,13.463,12.126,12.126,0,0,0-6.672,2.571,7.232,7.232,0,0,0-.625-.474,11.238,11.238,0,0,1-.068-5.924,17.947,17.947,0,0,0-5.834,4.509H11.2c-.96-1.217-.893-5.232-.838-6.071a4.332,4.332,0,0,0-.809.43,17.646,17.646,0,0,0-2.369,2.029,21.157,21.157,0,0,0-2.266,2.718v0A20.467,20.467,0,0,0,1.67,20.606l-.033.16c-.046.213-.21,1.281-.238,1.513a.511.511,0,0,1-.006.053A23.1,23.1,0,0,0,1,25.674V25.8a24.238,24.238,0,0,0,48.119,4.1c.041-.313.074-.622.11-.938a24.927,24.927,0,0,0-1.572-12.175ZM19.726,35.761c.113.054.219.113.336.165l.017.011q-.176-.084-.353-.176ZM45.258,18.055v-.023l0,.026Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6106",
    "data-name": "Path 6106",
    d: "M47.66,16.363c-1.053-2.534-3.189-5.27-4.862-6.134a25.183,25.183,0,0,1,2.454,7.354v.023l0,.026A21.949,21.949,0,0,1,44.5,33.99C41.725,39.95,35,46.059,24.479,45.759,13.111,45.437,3.093,37,1.223,25.948a10.452,10.452,0,0,1,.171-4.043A18.059,18.059,0,0,0,1,25.25v.125a24.238,24.238,0,0,0,48.12,4.1c.041-.313.074-.622.11-.938A24.927,24.927,0,0,0,47.663,16.36Z",
    transform: "translate(0 0.426)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6107",
    "data-name": "Path 6107",
    d: "M47.66,16.363c-1.053-2.534-3.189-5.27-4.862-6.134a25.183,25.183,0,0,1,2.454,7.354v.023l0,.026A21.949,21.949,0,0,1,44.5,33.99C41.725,39.95,35,46.059,24.479,45.759,13.111,45.437,3.093,37,1.223,25.948a10.452,10.452,0,0,1,.171-4.043A18.059,18.059,0,0,0,1,25.25v.125a24.238,24.238,0,0,0,48.12,4.1c.041-.313.074-.622.11-.938A24.927,24.927,0,0,0,47.663,16.36Z",
    transform: "translate(0 0.426)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6108",
    "data-name": "Path 6108",
    d: "M34.942,19.634c.052.037.1.074.151.111a13.19,13.19,0,0,0-2.251-2.936C25.307,9.273,30.868.475,31.805.025l.009-.014a17.677,17.677,0,0,0-8.342,13.463c.283-.019.563-.043.852-.043a12.232,12.232,0,0,1,10.618,6.2Z",
    transform: "translate(0.936 0)",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6109",
    "data-name": "Path 6109",
    d: "M24.739,20.6c-.04.6-2.17,2.682-2.915,2.682-6.891,0-8.011,4.169-8.011,4.169a10.229,10.229,0,0,0,5.709,7.929c.135.07.272.133.409.2q.356.158.712.291a10.782,10.782,0,0,0,3.154.608c12.081.567,14.42-14.445,5.7-18.8a8.367,8.367,0,0,1,5.844,1.419,12.232,12.232,0,0,0-10.618-6.2c-.288,0-.569.024-.852.043A12.126,12.126,0,0,0,17.2,15.507c.37.313.787.73,1.665,1.6,1.645,1.62,5.863,3.3,5.872,3.5Z",
    transform: "translate(0.534 0.537)",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6110",
    "data-name": "Path 6110",
    d: "M24.739,20.6c-.04.6-2.17,2.682-2.915,2.682-6.891,0-8.011,4.169-8.011,4.169a10.229,10.229,0,0,0,5.709,7.929c.135.07.272.133.409.2q.356.158.712.291a10.782,10.782,0,0,0,3.154.608c12.081.567,14.42-14.445,5.7-18.8a8.367,8.367,0,0,1,5.844,1.419,12.232,12.232,0,0,0-10.618-6.2c-.288,0-.569.024-.852.043A12.126,12.126,0,0,0,17.2,15.507c.37.313.787.73,1.665,1.6,1.645,1.62,5.863,3.3,5.872,3.5Z",
    transform: "translate(0.534 0.537)",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6111",
    "data-name": "Path 6111",
    d: "M16.2,14.858c.2.125.358.234.5.332a11.237,11.237,0,0,1-.068-5.924A17.945,17.945,0,0,0,10.8,13.775c.118,0,3.634-.066,5.4,1.083Z",
    transform: "translate(0.408 0.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6112",
    "data-name": "Path 6112",
    d: "M1.215,26.052C3.086,37.1,13.1,45.543,24.471,45.862,35,46.16,41.718,40.05,44.495,34.093a21.949,21.949,0,0,0,.754-16.359v-.023c0-.018,0-.029,0-.023l0,.041c.86,5.614-2,11.05-6.46,14.733l-.014.031c-8.7,7.085-17.022,4.274-18.7,3.127q-.176-.084-.353-.176c-5.071-2.424-7.166-7.041-6.716-11.006a6.224,6.224,0,0,1-5.741-3.611,9.143,9.143,0,0,1,8.911-.358,12.068,12.068,0,0,0,9.1.358c-.009-.2-4.227-1.876-5.872-3.5-.879-.866-1.3-1.283-1.665-1.6a7.249,7.249,0,0,0-.625-.474c-.144-.1-.306-.2-.5-.332-1.768-1.149-5.283-1.086-5.4-1.083H11.2c-.961-1.218-.893-5.232-.838-6.071a4.332,4.332,0,0,0-.809.43,17.646,17.646,0,0,0-2.369,2.029,21.155,21.155,0,0,0-2.275,2.712v0a20.467,20.467,0,0,0-3.252,7.341c-.012.049-.873,3.814-.448,5.766Z",
    transform: "translate(0.004 0.324)",
    fill: "url(#radial-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6113",
    "data-name": "Path 6113",
    d: "M32.622,16.808a13.2,13.2,0,0,1,2.251,2.939c.133.1.258.2.363.3,5.495,5.065,2.616,12.225,2.4,12.732C42.1,29.1,44.954,23.659,44.1,18.043c-2.741-6.835-7.391-9.593-11.181-15.59-.192-.3-.384-.607-.571-.928-.107-.183-.193-.348-.267-.5a4.409,4.409,0,0,1-.361-.96A.063.063,0,0,0,31.662,0a.086.086,0,0,0-.046,0S31.608.009,31.6.01l-.017.009c-.937.445-6.5,9.249,1.038,16.778Z",
    transform: "translate(1.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6114",
    "data-name": "Path 6114",
    d: "M35.629,19.321c-.106-.1-.23-.2-.363-.3-.049-.037-.1-.074-.151-.111a8.367,8.367,0,0,0-5.844-1.419c8.717,4.359,6.378,19.367-5.7,18.8a10.779,10.779,0,0,1-3.154-.608q-.356-.133-.712-.291c-.137-.063-.274-.125-.409-.2l.017.011c1.685,1.15,10.005,3.96,18.7-3.127l.014-.031c.217-.507,3.1-7.667-2.4-12.732Z",
    transform: "translate(0.762 0.726)",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6115",
    "data-name": "Path 6115",
    d: "M14.1,27.2s1.119-4.169,8.011-4.169c.745,0,2.877-2.079,2.915-2.682a12.068,12.068,0,0,1-9.1-.358,9.143,9.143,0,0,0-8.911.358,6.224,6.224,0,0,0,5.741,3.611c-.449,3.963,1.646,8.58,6.716,11.006.113.054.219.113.336.165A10.231,10.231,0,0,1,14.1,27.2Z",
    transform: "translate(0.251 0.792)",
    fill: "url(#radial-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6116",
    "data-name": "Path 6116",
    d: "M47.66,16.788c-1.053-2.534-3.189-5.27-4.862-6.135a25.184,25.184,0,0,1,2.454,7.354l0,.041c-2.74-6.829-7.385-9.586-11.181-15.583-.192-.3-.384-.607-.571-.928-.107-.183-.193-.348-.267-.5a4.409,4.409,0,0,1-.361-.96.062.062,0,0,0-.055-.063.086.086,0,0,0-.046,0s-.008.006-.012.007L32.746.03l.009-.016a17.677,17.677,0,0,0-8.342,13.463c.283-.019.563-.043.852-.043a12.232,12.232,0,0,1,10.618,6.2,8.367,8.367,0,0,0-5.844-1.419c8.717,4.359,6.378,19.367-5.7,18.8a10.782,10.782,0,0,1-3.154-.608q-.356-.133-.712-.291c-.137-.062-.274-.125-.409-.2l.017.011q-.176-.084-.353-.176c.113.054.219.113.336.165A10.233,10.233,0,0,1,14.355,28s1.119-4.169,8.011-4.169c.745,0,2.877-2.079,2.915-2.682-.009-.2-4.227-1.876-5.872-3.5-.879-.866-1.3-1.283-1.665-1.6a7.233,7.233,0,0,0-.625-.474,11.237,11.237,0,0,1-.068-5.924,17.945,17.945,0,0,0-5.834,4.509H11.2c-.961-1.218-.893-5.232-.838-6.071a4.332,4.332,0,0,0-.809.43,17.646,17.646,0,0,0-2.369,2.029A21.157,21.157,0,0,0,4.923,13.27v0a20.467,20.467,0,0,0-3.252,7.341l-.033.16c-.046.213-.25,1.3-.28,1.529A28.2,28.2,0,0,0,1,25.679V25.8a24.238,24.238,0,0,0,48.12,4.1c.041-.313.074-.622.11-.938a24.925,24.925,0,0,0-1.572-12.175Zm-2.4,1.245,0,.026Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxIcon);
export default __webpack_public_path__ + "static/media/firefox_icon.24edb44ff3a26a4ebdce4ff029165c1f.svg";
export { ForwardRef as ReactComponent };